export var QuestionnaireExitActionType;
(function (QuestionnaireExitActionType) {
    QuestionnaireExitActionType["LOGOUT"] = "exit-action::logout";
})(QuestionnaireExitActionType || (QuestionnaireExitActionType = {}));
